export default function SectionLoader() {
    return (
        <div
            style={{
                width: "100%",
                padding: "40px 0",
                display: "flex",
                marginLeft: "5rem",
                flexDirection: "column",
                minHeight: "120px"
            }}
        >
            {/* spinner */}
            <div
                style={{
                    width: "40px",
                    height: "40px",
                    border: "4px solid #ccc",
                    borderTop: "4px solid #0275d8",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    marginBottom: "12px",
                    marginLeft: "8px"
                }}
            />

            {/* label */}
            <div style={{ color: "#272db8", fontSize: "14px", fontWeight: "bold" }}>
                Loading…
            </div>

            <style>
                {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}
            </style>
        </div>
    );
}
